import { Engineering } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { MainLayoutContainer } from "components/Layout";
import { FC } from "react";

export const UnderConstruction: FC = () => {
  return (
    <MainLayoutContainer title="Under Construction">
      <Box sx={{ width: "100%", textAlign: "center" }} my={4}>
        <Engineering sx={{ fontSize: "5rem" }} />
        <Typography>We are still working on this page</Typography>
      </Box>
    </MainLayoutContainer>
  );
};
